<!--MENÚ CONTEXTUAL OCULTO -->
<div id="menuIzq" style="position: fixed;" [style.left]="menuTopLeftPosition.x" [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu">
  <mat-menu #rightMenu="matMenu">
    <ng-template matMenuContent let-item="item">

      <button mat-menu-item (click)="deleteArchivo()">
        <mat-icon class="iconoMenVer" [ngStyle]="{'color':'grey'}">delete</mat-icon>
        {{'gestion.seguimiento.objetivos.formText1' | translate}}
      </button>
    </ng-template>
  </mat-menu>
</div>

<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.periodo' | translate"
    [array]="aniosDisponibles"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioAnio($event)"
    [click]="false"
  />

  <app-filters filtros
    [name]="'filtros.pers' | translate" 
    [array]="perspectives"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="todasPer"
    (eventClick)="cambioPer($event)"
  />

  <app-filters filtros
    [name]="'filtros.res' | translate" 
    [array]="responsables"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="selAll"
    (eventClick)="cambioLider($event)"
  />

  <div borrador [ngStyle]="{'color':'gray'}" class="iconoMen"
    (click)="borrarFiltros()" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
    <img src="./../../../../assets/img/eraser.png">
  </div>

  <div contenido class="contenidoClass">
    <div class="zona1">
      <app-contenedor-elementos [header]="{
        title: 'gestion.seguimiento.objetivos.formText2'| translate,
        subtitles: [{text: Periodo}]
      }">
        <mat-icon iconos class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menutabla">more_vert</mat-icon>
        <mat-menu #menutabla="matMenu">
          <button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'gestion.seguimiento.objetivos.formText3' | translate }}</span>
          </button>
        </mat-menu>

        <div body class="tablaObjetivos">
          @if (viewTablero) {
            <table class="tabla-aleema">
              <thead>
                <tr>
                  <th>{{ 'gestion.seguimiento.objetivos.col1' | translate }}</th>
                  <th>{{ 'gestion.seguimiento.objetivos.col2' | translate }}</th>
                  @if(verCodigo) {
                    <th>{{'gestion.seguimiento.objetivos.col3' | translate }}</th>
                  }
                  <th>{{ 'gestion.seguimiento.objetivos.col4' | translate }}</th>
                  <th>{{ 'gestion.seguimiento.objetivos.col5' | translate }}</th>
                  <th>{{ 'gestion.seguimiento.objetivos.col6' | translate }}</th>
                  <th>{{ 'gestion.seguimiento.objetivos.col7' | translate }}</th>
                  <th>{{ 'gestion.seguimiento.objetivos.col8' | translate }}</th>
                  @if(indicadoresMostrar.length !== 0) {
                    @for(ad of indicadoresMostrar[0].additions; track ad.id) {
                      @if(ad.type !== 'texto' && ad.type !== 'moneda' && ad.type !== 'numero') {
                        <th>{{ad.name}}</th>
                      }
                      @if(ad.type === 'texto' || ad.type === 'numero') {
                        <th>{{ad.name}}</th>
                      }
                      @if(ad.type === 'moneda') {
                        <th>{{ad.name}}</th>
                      }
                    }
                  }
                </tr>
              </thead>
              <tbody>
                @for(ind of indicadoresMostrar; track ind.id; let i = $index) {
                  <tr>
                    <td class="textoOverFlow anchos"
                    [matTooltip]="escribirPer(ind,i)" [appOverflowTooltip]="escribirPer(ind,i)">
                      {{escribirPer(ind,i)}}
                    </td>
                    <td class="textoOverFlow anchos"
                    [matTooltip]="escribirObj(ind,i)" [appOverflowTooltip]="escribirObj(ind,i)">
                      {{escribirObj(ind,i)}}
                    </td>
                    @if(verCodigo) {
                      <td class="textoOverFlow anchos" matTooltip="Código">
                        {{'gestion.seguimiento.objetivos.col3' | translate }}
                      </td>
                    }
                    <td class="textoOverFlow anchos"
                    [matTooltip]="ind.nombre" [appOverflowTooltip]="ind.nombre">
                      {{ind.nombre}}
                    </td>
                    <td class="textoOverFlow anchos"
                    [matTooltip]="obtRes(i)" [appOverflowTooltip]="obtRes(i)">
                      {{obtRes(i)}}
                    </td>
                    @for(an of aniosDisponibles; track an.id) {
                      @for(mes of an.series; track mes.id) {
                        @if(mes.check) {
                          <td class="textoOverFlow w3-center anchosN"
                          [matTooltip]="escribirMeta(mes.periodo, ind)" [appOverflowTooltip]="escribirMeta(mes.periodo, ind)">
                            {{escribirMeta(mes.periodo, ind)}}
                          </td>
                            <ng-container *appRoles="permisos.SEGUIMIENTO">
                              @if(escribirMeta(mes.periodo, ind) != '') {
                                <td class="anchosN textoOverFlow w3-center" (dblclick)="editar(mes.periodo,ind)"
                                style="cursor: pointer; background-color: #E0E0E0;"
                                [matTooltip]="escribirMeta(mes.periodo, ind)" [appOverflowTooltip]="escribirMeta(mes.periodo, ind)">
                                  @if(escribirReal(mes.periodo, ind) !== 'null') {
                                    {{escribirReal(mes.periodo, ind)}}
                                  }
                                  @if(escribirReal(mes.periodo, ind) === 'null') {
                                    -
                                  }
                                </td>
                              }
                            </ng-container>
                            <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                              @if(escribirMeta(mes.periodo, ind) !== '') {
                                <td class="anchosN textoOverFlow w3-center" style="cursor: pointer; background-color: #E0E0E0;"
                                [matTooltip]="escribirMeta(mes.periodo, ind)" [appOverflowTooltip]="escribirMeta(mes.periodo, ind)">
                                  @if(escribirReal(mes.periodo, ind) !== 'null') {
                                    {{escribirReal(mes.periodo, ind)}}
                                  }
                                  @if(escribirReal(mes.periodo, ind) === 'null') {
                                    -
                                  }
                                </td>
                              }
                            </ng-container>
                          <td class="anchosN alinDer textoOverFlow w3-center"
                            [ngClass]="pintarBorde(escribirReal(mes.periodo, ind,'s'),
                            escribirMeta(mes.periodo, ind,'s'), rendimiento(mes.periodo, ind))">
                              {{rendimiento(mes.periodo, ind)}}
                          </td>
                        }
                      }
                    }
                    @for(ad of ind.additions; track ad.id) {
                      <ng-container *appRoles="permisos.SEGUIMIENTO">
                        @if(ad.type !== 'moneda' && ad.type !== 'archivo' && ad.type !== 'numero') {
                          <td [ngClass]="true? 'borderSup borderInfLow':''"
                          class="textoOverFlow w3-center anchosad" style="cursor: pointer;"
                          (dblclick)="edicionAd(ad, ind.id, $event)"
                          [matTooltip]="escribirAdicional(ad)" [appOverflowTooltip]="escribirAdicional(ad)">
                            {{escribirAdicional(ad)}}
                          </td>
                        }
                      </ng-container>
                      <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                        @if(ad.type !== 'moneda' && ad.type !== 'archivo') {
                          <td [ngClass]="true? 'borderSup borderInfLow':''"
                          class="textoOverFlow borderAllLow w3-center anchosad"
                          [matTooltip]="escribirAdicional(ad)" [appOverflowTooltip]="escribirAdicional(ad)">
                            {{escribirAdicional(ad)}}
                          </td>
                        }
                      </ng-container>
                      @if(ad.type === 'moneda') {
                        <td [ngClass]="true? 'borderSup borderInfLow':''"
                        class="textoOverFlow borderAllLow w3-center anchosad alinDer"
                        [matTooltip]="escribirAdicional(ad)" [appOverflowTooltip]="escribirAdicional(ad)">
                          {{escribirAdicional(ad)}}
                        </td>
                      }
                      @if(ad.type === 'numero') {
                        <td [ngClass]="true? 'borderSup borderInfLow':''"
                        class="textoOverFlow borderAllLow w3-center anchosad alinIzq"
                        [matTooltip]="escribirAdicional(ad)" [appOverflowTooltip]="escribirAdicional(ad)">
                          {{escribirAdicional(ad)}}
                        </td>
                      }
                      <ng-container *appRoles="permisos.SEGUIMIENTO">
                        @if(ad.type === 'archivo') {
                        <td class="textoOverFlow borderAllLow w3-center anchosad">
                          @if(escribirAdicional(ad) !== '') {
                            <div class="iconoArch" style="cursor: pointer;" (contextmenu)="onContextMenu($event, ad)"
                              (click)="abirPDF(ad, $event);">
                              <mat-icon matTooltip="{{escribirAdicional(ad)}}" class="icono"
                                [ngStyle]="{'color':'#4E9AC7'}">attach_file</mat-icon>
                            </div>
                          }
                          @if(escribirAdicional(ad) === '') {
                            <div class="iconoArch" style="cursor: pointer;" (dblclick)="edicionAd(ad, $event)">
                              <mat-icon matTooltip="Adjuntar archivo" class="icono"
                                [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
                            </div>
                          }
                        </td>
                        }
                      </ng-container>
                      <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                        @if(ad.type === 'archivo') {
                        <td class="textoOverFlow borderAllLow w3-center anchosad">
                            @if(escribirAdicional(ad) !== '') {
                            <div class="iconoArch" style="cursor: pointer;" (click)="abirPDF(ad, $event);">
                              <mat-icon matTooltip="{{escribirAdicional(ad)}}" class="icono"
                                [ngStyle]="{'color':'#4E9AC7'}">attach_file</mat-icon>
                            </div>
                            }
                            @if(escribirAdicional(ad) === '') {
                            <div class="iconoArch">
                              <mat-icon class="icono" [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
                            </div>
                            }
                        </td>
                        }
                      </ng-container>
                    }
                  </tr>
                }
              </tbody>
            </table>
            }@else {
            <app-skeleton-table [columnas]="15" [filas]="7" />
            }
        </div>
      </app-contenedor-elementos>
    </div>

    @if(viewTablero) {
      <div class="zona2">
        <div class="contenedorN">
          <div class="zoneNewTarjets">
            <div class="zone1T" [ngClass]="pintarBordeT(porcentajeAvance)">
              <div class="textoNombre">
                {{'gestion.seguimiento.objetivos.formText4' | translate }}
              </div>
            </div>
            <div class="zone2T">
              @if (porcentajeAvance !== undefined) {
              <div class="zonaTexto">
                <div [ngClass]="texto(porcentajeAvance)" class="textoNumero">
                  {{porcentajeAvance}}%
                </div>
              </div>
              }
              @if (porcentajeAvance === undefined) {
              <div class="zonaTexto">
                <div [ngClass]="texto(porcentajeAvance)" class="textoNumero">
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        <div class="contenedorN">
          @for(per of perspectives; track per.id) {
            <div class="zoneNewTarjets">
              <div class="zone1T" [ngClass]="pintarBordeT(per.avance)" matTooltipPosition="right" matTooltipShowDelay="1000"
                matTooltip="{{per.name}}">
                <div class="textoNombre">
                  {{per.name}}
                </div>
              </div>
              <div class="zone2T">
                @if (per.avance !== undefined) {
                <div class="zonaTexto">
                  <div [ngClass]="texto(per.avance)" class="textoNumero">
                    {{per.avance}}%
                  </div>
                </div>
                }
                @if (per.avance === undefined) {
                <div class="zonaTexto">
                  <div [ngClass]="texto(per.avance)" class="textoNumero">
                  </div>
                </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }@else {
      <div class="w3-row w3-rest">
        <div class="w3-row w3-quarter" style="height: 15vh;">
          <div class="w3-row w3-twothird" style="height: 100%;">
            <ngx-skeleton-loader [theme]="{
                'border-radius': '10px',
                height: '90%',
                width: '90%',
                margin: '4px 4px 4px 25px',
              }" />
          </div>
          <div class="w3-row w3-rest" style="height: 100%;">
            <ngx-skeleton-loader [theme]="{
                'border-radius': '10px',
                height: '90%',
                width: '98%',
                margin: '4px 4px 4px 4px',
              }" />
          </div>
        </div>
      </div>
      <div class="w3-row">
        <div class="w3-row w3-quarter" style="height: 15vh;">
          <div class="w3-row w3-twothird" style="height: 100%;">
            <ngx-skeleton-loader [theme]="{
                'border-radius': '10px',
                height: '90%',
                width: '90%',
                margin: '4px 4px 4px 25px',
              }" />
          </div>
          <div class="w3-row w3-rest" style="height: 100%;">
            <ngx-skeleton-loader [theme]="{
                'border-radius': '10px',
                height: '90%',
                width: '98%',
                margin: '4px 4px 4px 4px',
              }" />
          </div>
        </div>
        <div class="w3-row w3-quarter" style="height: 15vh;">
          <div class="w3-row w3-twothird" style="height: 100%;">
            <ngx-skeleton-loader [theme]="{
                'border-radius': '10px',
                height: '90%',
                width: '90%',
                margin: '4px 4px 4px 25px',
              }" />
          </div>
          <div class="w3-row w3-rest" style="height: 100%;">
            <ngx-skeleton-loader [theme]="{
                'border-radius': '10px',
                height: '90%',
                width: '98%',
                margin: '4px 4px 4px 4px',
              }" />
          </div>
        </div>
        <div class="w3-row w3-quarter" style="height: 15vh;">
          <div class="w3-row w3-twothird" style="height: 100%;">
            <ngx-skeleton-loader [theme]="{
                'border-radius': '10px',
                height: '90%',
                width: '90%',
                margin: '4px 4px 4px 25px',
              }" />
          </div>
          <div class="w3-row w3-rest" style="height: 100%;">
            <ngx-skeleton-loader [theme]="{
                'border-radius': '10px',
                height: '90%',
                width: '98%',
                margin: '4px 4px 4px 4px',
              }" />
          </div>
        </div>
      </div>
    }
  </div>
</app-esqueleto-tableros>